import { AxiosInstance } from 'axios';
import RedisApiAxiosInstance from 'services/api/RedisApiAxiosInstance/RedisApiAxiosInstance';
import { loadRemoteModule } from 'moduleFederation/moduleFederationRuntime';
import { Config } from '../../config';
import store from '../../store';
import { accountIdSelector } from '../../store/auth/auth.selectors';

type RdiInitApiService = (options: {
  axiosInstance: AxiosInstance;
  isRelative: boolean;
  env: string;
  accountId?: number;
}) => void;

const initRdiMFEApiService = async () => {
  try {
    const { default: apiService } = await loadRemoteModule<{ default: RdiInitApiService }>(
      'rdi/initApiService'
    );
    if (!apiService) {
      return;
    }
    const accountIdStr = accountIdSelector(store.getState());
    const accountId = accountIdStr ? parseInt(accountIdStr, 10) : undefined;
    apiService({
      axiosInstance: RedisApiAxiosInstance,
      isRelative: Config.IS_RELATIVE_API,
      env: Config.API_ENV,
      accountId
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('cannot load initRdiMFEApiService', e);
  }
};

export default initRdiMFEApiService;
